import { render } from "./FuncionPage.vue?vue&type=template&id=01f12968&scoped=true"
import script from "./FuncionPage.vue?vue&type=script&lang=js"
export * from "./FuncionPage.vue?vue&type=script&lang=js"

import "./FuncionPage.vue?vue&type=style&index=0&id=01f12968&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f12968"]])

export default __exports__